/**
 * 会议聊天窗口选择聊天对象
 */
import { Popover } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import "./index.less";
import { Avatar } from "@/baseComponents/Avatar";
import { changeEgovUrl } from "@/utils/tools";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import classNames from "classnames";
import selected from "./img/selected.png";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import { Employee } from "@/types/chat";
import PinyinMatch from "pinyin-match";
import { getClientType } from "@/utils";
import { isGroupAdmin, isGroupOwner } from "@/utils/chat/group";

function MemberContent({
  members,
  onclick,
  currentEmployee,
  listLen,
  privateUser,
  setPrivateUser
}: {
  members: any;
  onclick: any;
  currentEmployee: Employee;
  listLen: number;
  privateUser: any;
  setPrivateUser: any;
}) {
  const [sendName, setsendName] = useState("所有人");
  const [newMembers, setnewMembers] = useState(members);
  useEffect(() => {
    setsendName(privateUser?.userName);
    setnewMembers(members);
  }, [members, privateUser?.userName]);
  function getAvatar(user: any) {
    return (
      <Avatar
        styleObj={{
          width: "36px",
          height: "36px"
        }}
        src={user.avatar ? changeEgovUrl(getHeadImgThumbUrl(user.avatar, 150, 150)) : ""}
        className="avatarNoDraggable"
        name={user.name}
      />
    );
  }
  function setUser(user: any) {
    onclick();
    setsendName(user.name);
    let privateUser;
    if (user?.userId === "all") {
      privateUser = {
        pin: "all",
        userName: "所有人"
      };
    } else {
      privateUser = {
        app: user.app || "",
        teamId: user.teamId || "",
        userName: user.name || "",
        pin: user.userId || "",
        unitName: user.desc || "",
        clientType: user.deviceType || ""
      };
    }
    setPrivateUser(privateUser);
  }
  function handleChange(event: any) {
    const searchValue = event.target.value;
    let matchMembers: any = [];
    // eslint-disable-next-line array-callback-return
    members.map((user: any) => {
      const result = PinyinMatch.match(user.name, searchValue);
      if (result) {
        matchMembers.push(user);
        setnewMembers(matchMembers);
      } else {
        setnewMembers(matchMembers);
      }
    });
  }
  return (
    <div className="meeting-container">
      <input className="my-input" onChange={handleChange} placeholder="搜索成员" />
      {newMembers.length !== 0 ? (
        newMembers.map((user: any, index: number) => {
          if (user?.userId !== currentEmployee?.userId || user.clientType !== getClientType()) {
            return (
              <div className="meeting-list" onClick={() => setUser(user)} key={index}>
                {sendName === user.name ? (
                  <img src={selected} />
                ) : (
                  <span style={{ width: 12, height: 9 }} />
                )}
                <div className="avatar">{getAvatar(user)}</div>
                <div className="name-tag">
                  <div className="name-tag-name">
                    <div className="user_name" dangerouslySetInnerHTML={{ __html: user.name }} />
                    {user?.userId === "all" && <span>({listLen})</span>}
                    {isGroupOwner(user.identity) && (
                      <div className="is_moderator identity">主持人</div>
                    )}
                    {isGroupAdmin(user.identity) && (
                      <div className="is_Assistant identity">联席主持人</div>
                    )}
                  </div>
                  <div className="descInfo">
                    <div
                      className="descInfo_content"
                      dangerouslySetInnerHTML={{
                        __html: user.desc || ""
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          } else {
            return null;
          }
        })
      ) : (
        <div className="no-result">未找到结果</div>
      )}
    </div>
  );
}
function MembersPopover({
  children,
  visible,
  onVisibleChange,
  members,
  placement,
  currentEmployee,
  listLen,
  privateUser,
  setPrivateUser
}: {
  children: any;
  visible: boolean;
  onVisibleChange: (visible: boolean) => void;
  members: any;
  placement?: any;
  currentEmployee: Employee;
  listLen: number;
  privateUser: any;
  setPrivateUser: any;
}) {
  function handleClick() {
    onVisibleChange(false);
  }
  const classes = useMemo(() => {
    return classNames({
      "meet-popover": true
    });
  }, []);
  return (
    <Popover
      trigger="click"
      overlayClassName={classes}
      placement={placement || "bottom"}
      visible={visible}
      onVisibleChange={(visible) => {
        onVisibleChange(visible);
      }}
      content={
        <MemberContent
          members={members}
          onclick={handleClick}
          currentEmployee={currentEmployee}
          listLen={listLen}
          privateUser={privateUser}
          setPrivateUser={setPrivateUser}
        />
      }
    >
      {children}
    </Popover>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  return {
    currentEmployee: chat.currentEmployee,
    privateUser: chat.privateUser
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    setPrivateUser(data: any) {
      dispatch({ type: "chat/setPrivateUser", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MembersPopover);
